import Layout from '@/layout'

// GIMMATEK 店家首頁不提供 banner、公告、幫助中心（CNCY-10767）
export default [
  {
    path: '/homepage',
    name: 'ShopHomePage',
    component: Layout,
    meta: {
      title: 'page.homePage.title',
      // action: 'admin.lineConfig.page',
    },
    children: [
      {
        path: '',
        name: 'HomePage',
        component: () => import('@/views/HomePage/HomePage'),
        meta: {
          title: 'page.homePage.title',
          // action: 'admin.lineConfig.page',
        },
      },
    ],
  },
]
